import * as React from "react"
import * as SwitchPrimitives from "@radix-ui/react-switch"

import { cn } from "@/lib/utils"

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  /* !min-h-0 keeps the track a 24px pill: the mobile rule that gives every
     button 44px (button:not([size=icon]), more specific than a utility)
     stretched it into a circle. The ::before (10px above and
     below) gives back the 44px tap target without changing how it looks. */
  <SwitchPrimitives.Root
    className={cn(
      "peer relative inline-flex h-6 !min-h-0 !min-w-0 w-11 shrink-0 cursor-pointer before:absolute before:inset-x-0 before:-top-2.5 before:-bottom-2.5 before:content-[''] items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
      className
    )}
    {...props}
    ref={ref}
  >
    {/* A literal white, not `bg-white`: dark mode's [class*="bg-white"]
        override repaints that as the card colour, and a dark thumb on the
        dark track disappears. */}
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none block h-5 w-5 rounded-full bg-[hsl(0_0%_100%)] shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0"
      )}
    />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
